import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { getTerminalId } from "../helpers";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetOverageEntryDetailsAPI = async (osdNumber: number | string): Promise<IOvEntry> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.OVERAGE_ENTRY_DETAILS) || {};
    // Add dynamic OSD-Exception-Number and OSD-Reporting-Terminal
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Reporting-Terminal": getTerminalId(),
    };
    const response = await axios.get<any>(`${getUrl(ApiType.OVERAGE_ENTRY_DETAILS)}/${osdNumber}`, { headers });
    return response.data;
  } catch (error) {
    return throwApiError(error, ErrorMessages.overageEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
